import { render, staticRenderFns } from "./vipServe.vue?vue&type=template&id=229c9486&scoped=true&"
import script from "./vipServe.vue?vue&type=script&lang=js&"
export * from "./vipServe.vue?vue&type=script&lang=js&"
import style0 from "./vipServe.vue?vue&type=style&index=0&id=229c9486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229c9486",
  null
  
)

export default component.exports